import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  createWritingQuestion,
  updateWritingQuestion,
  getWritingQuestion,
} from '../../api/writingApi';
import { TextField, Button, Box, Typography } from '@mui/material';
import { useToast } from '../../contexts/ToastContext';
import Editor from '../../components/common/Editor'; // Your custom Quill Editor component

const WritingQuestionForm = () => {
  const { writingId, questionId } = useParams();
  const navigate = useNavigate();
  const editorRef = useRef();
  const { showToast } = useToast();

  const [formData, setFormData] = useState({
    Label: '',
    Image: '',
  });

  useEffect(() => {
    if (questionId) {
      const fetchQuestion = async () => {
        try {
          const question = await getWritingQuestion(writingId, questionId);
          if (question) {
            setFormData(question);
            // Set editor content after a small delay to ensure ref is ready
            setTimeout(() => {
              if (editorRef.current && question.Label) {
                editorRef.current.setHTML(question.Label);
              }
            }, 100);
          } else {
            console.error('Question not found');
          }
        } catch (error) {
          console.error('Failed to fetch question:', error);
        }
      };
      fetchQuestion();
    }
  }, [writingId, questionId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const editorContent = editorRef.current?.getHTML();
    try {
      const updatedData = { ...formData, Label: editorContent };
      if (questionId) {
        await updateWritingQuestion(writingId, questionId, updatedData);
      } else {
        await createWritingQuestion(writingId, updatedData);
      }
      showToast('Question saved successfully!', 'success');
      navigate(`/writings/${writingId}/questions`);
    } catch (error) {
      console.error('Failed to save question:', error);
      showToast('Failed to save question', 'error');
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: '0 auto', padding: 4 }}>
      <Typography variant="h4" gutterBottom>
        {questionId ? 'Edit Writing Question' : 'Create Writing Question'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>
          Question Content
        </Typography>
        <Editor
          ref={editorRef}
          defaultValue={formData.Label || ''}
          key={`editor-${questionId || 'new'}-${formData.Label || 'empty'}`}
        />
        <TextField
          label="Image URL"
          name="Image"
          value={formData.Image}
          onChange={(e) =>
            setFormData({ ...formData, Image: e.target.value })
          }
          fullWidth
          margin="normal"
        />
        <Box sx={{ marginTop: 4 }}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Save Question
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default WritingQuestionForm;
